import {Navigate, NonIndexRouteObject} from "react-router"
import {ErrorPage} from "../components/page";
import {
    navigationStore,
    pageQueryStore, stsCreateStore,
    stsCustomerStore,
    stsDetailStore,
    stsOverviewStore, stsZebraPrinterStore,
    validationStore
} from "../store";
import React from "react";
import {StsApp} from "../components/app/StsApp";
import {StorageTransferStatusDto} from "../api/sts";


const sts: NonIndexRouteObject[] = [
    {
        path: `/sts`,
        element: <StsApp mode={'overview'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            await stsCustomerStore.init()
            const searchParams = new URL(request.url).searchParams
            pageQueryStore.updateSystem('sts', searchParams)

            stsOverviewStore.page = parseInt(searchParams.get("page") || "") || 1
            stsOverviewStore.size = parseInt(searchParams.get("size") || "") || 25

            stsOverviewStore.query = searchParams.get('q') || undefined
            stsOverviewStore.fromRelative = searchParams.get('fromRelative') || undefined
            stsOverviewStore.toRelative = searchParams.get('toRelative') || undefined
            stsOverviewStore.fromAbsolute = searchParams.get('fromAbsolute') || undefined
            stsOverviewStore.toAbsolute = searchParams.get('toAbsolute') || undefined
            stsOverviewStore.customerId = searchParams.get('customerId') || undefined
            stsOverviewStore.status = searchParams.getAll('status') as StorageTransferStatusDto[] || undefined

            stsOverviewStore.load().finally()
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/sts/create`,
        element: <StsApp mode={'create'}/>,
        errorElement: <ErrorPage/>,
        loader: async ({request}) => {
            validationStore.reset()
            stsCreateStore.reset()
            await Promise.all([
                await stsCustomerStore.init(),
                await stsZebraPrinterStore.load(),
            ])
            navigationStore.setActivePath(request)
            return null
        }
    },
    {
        path: `/sts/:id`,
        element: <StsApp mode={'detail'}/>,
        errorElement: <Navigate to={`/sts`} replace={true}/>,
        loader: async ({params, request}) => {
            validationStore.reset()
            stsDetailStore.id = params.id!!
            await stsCustomerStore.init()
            const result = await stsDetailStore.load()
            if (!result) {
                throw Error
            }
            navigationStore.setActivePath(request)
            return null
        }
    },
]

export {
    sts
}
